<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .user-view {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(12px);
    padding-bottom: utils.in_rem(32px);
    position: relative;
    justify-content: space-between;

    .top-row {
      display: flex;
      align-items: center;
      justify-content: center;
      height: utils.in_rem(48px);
      position: relative;
    }

    .status-banner-wrapper {
      padding: utils.in_rem(8px) utils.in_rem(12px);
      position: absolute;
      top: 60px;
      width: 90%;
      z-index: 10;
    }

    .profile-section {
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
    }
  }
</style>

<script>
  import StatusBanner from "../components/StatusBanner.svelte";

  import Button from "../../../../../../svelte-design-system/components/atoms/Button.svelte";
  import { attendeesState } from "../attendeesState.svelte";
  import CallAttendee from "../components/CallAttendee.svelte";
  import ConferenceCall from "../components/ConferenceCall.svelte";
  import DiallerTopRow from "../components/DiallerTopRow.svelte";
  import UserControls from "../components/UserControls.svelte";
  import { diallerState } from "../diallerState.svelte";

  const candidate = $derived(attendeesState.candidate);
  const isConferenceCall = $derived(diallerState.isConferenceCall);
  const manager = $derived(attendeesState.manager);
  const showCoachBanner = $derived(
    manager && ["participate", "coach"].includes(manager.mode)
  );

  const saveContact = () => {
    diallerState.viewMode = "saveContact";
  };
</script>

<div class="user-view">
  <DiallerTopRow />

  <div class="status-banner-wrapper">
    {#if showCoachBanner}
      <StatusBanner type={manager.mode} userName={manager.name} />
    {/if}
  </div>

  <div class="profile-section">
    {#if isConferenceCall}
      <ConferenceCall />
    {:else}
      <CallAttendee attendee={candidate} />

      {#if !candidate?.candidateId}
        <Button size="small" kind="ghost-blue" onclick={saveContact}>
          Save Contact
        </Button>
      {/if}
    {/if}
  </div>

  <UserControls />
</div>
